"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadUnprocessableEntityError = void 0;
const client_library_1 = require("@seneca/client-library");
class FileUploadUnprocessableEntityError extends client_library_1.ExtendableError {
}
exports.FileUploadUnprocessableEntityError = FileUploadUnprocessableEntityError;
//# sourceMappingURL=FileUploadUnprocessableEntityError.js.map